/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type RelatedClientDetailType = (typeof RelatedClientDetailType)[keyof typeof RelatedClientDetailType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RelatedClientDetailType = {
  related: "related",
} as const;
